import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "brand-logo-overrides-page" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
import { ref, onMounted, nextTick, watch, useTemplateRef } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import { cleanBrandName } from '@/utils/helpers';
import AdminTable from '@/admin/components/AdminTable.vue';
import MGDialog from '@/components/elements/MGDialog.vue';
import MGButton from '@/components/elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BrandLogoOverridesPage',
    setup(__props) {
        const admin = useAdmin();
        const overridesTable = useTemplateRef('overridesTable');
        const loading = ref(false);
        const overrides = ref([]);
        const showDeleteDialog = ref(false);
        const deleteRow = ref(null);
        const showValidationToast = ref(false);
        const validationMessage = ref('');
        const previewSrc = ref(null);
        const previewPending = ref(false);
        const columns = [
            {
                field: 'searchRegEx',
                label: 'Search Regex',
                width: '2fr',
                sortable: true,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'e.g., ^AMAZON.*'
            },
            {
                field: 'override',
                label: 'Override',
                width: '2fr',
                sortable: true,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'e.g., Amazon'
            },
            {
                field: 'preview',
                label: 'Preview',
                width: '80px',
                sortable: false,
                editable: false
            }
        ];
        let _previewTimer = null;
        function _cleanBrandName(name) {
            return cleanBrandName(name);
        }
        function onOverrideInput(val) {
            console.log('[BrandLogoPreview] onOverrideInput called with:', val);
            previewSrc.value = null;
            previewPending.value = !!val;
            clearTimeout(_previewTimer);
            if (val) {
                _previewTimer = setTimeout(() => {
                    const cleanedName = cleanBrandName(val);
                    const url = 'https://api.sysodev.link/BrandLogos/' + cleanedName.replace(/[ /]/g, '+');
                    console.log('[BrandLogoPreview] cleanedName:', cleanedName);
                    console.log('[BrandLogoPreview] previewSrc URL:', url);
                    previewSrc.value = url;
                    previewPending.value = false;
                }, 1000);
            }
        }
        function loadOverrides() {
            loading.value = true;
            admin.getLogoSearchOverrides((data) => {
                overrides.value = data;
                loading.value = false;
            });
        }
        function handleAdd(data) {
            if (!data.searchRegEx || !data.override) {
                const missing = [];
                if (!data.searchRegEx)
                    missing.push('Search Regex');
                if (!data.override)
                    missing.push('Override');
                validationMessage.value = `Please fill in: ${missing.join(' and ')}`;
                showValidationToast.value = true;
                return;
            }
            admin.createLogoSearchOverride({ searchRegEx: data.searchRegEx, override: data.override.replace(/\//g, '') }, () => {
                loadOverrides();
                overridesTable.value?.resetAddRow();
            }, (err) => {
                validationMessage.value = err;
                showValidationToast.value = true;
            });
        }
        function handleEditSave({ rowId, data }) {
            if (!data.searchRegEx || !data.override) {
                const missing = [];
                if (!data.searchRegEx)
                    missing.push('Search Regex');
                if (!data.override)
                    missing.push('Override');
                validationMessage.value = `Please fill in: ${missing.join(' and ')}`;
                showValidationToast.value = true;
                return;
            }
            admin.updateLogoSearchOverride(rowId, { searchRegEx: data.searchRegEx, override: data.override.replace(/\//g, '') }, () => {
                overridesTable.value?.cancelEdit();
                loadOverrides();
            }, (err) => {
                validationMessage.value = err;
                showValidationToast.value = true;
            });
        }
        function handleDelete(row) {
            deleteRow.value = row;
            showDeleteDialog.value = true;
        }
        function confirmDelete() {
            if (!deleteRow.value)
                return;
            admin.deleteLogoSearchOverride(deleteRow.value.id, () => {
                overrides.value = overrides.value.filter((o) => o.id !== deleteRow.value.id);
                deleteRow.value = null;
                showDeleteDialog.value = false;
            }, (err) => {
                validationMessage.value = err;
                showValidationToast.value = true;
                showDeleteDialog.value = false;
            });
        }
        onMounted(() => {
            loadOverrides();
            nextTick(() => {
                const table = overridesTable.value;
                if (table) {
                    watch(() => table.editingData?.override, (val) => onOverrideInput(val));
                    watch(() => table.addRowData?.override, (val) => onOverrideInput(val));
                }
            });
        });
        return (_ctx, _cache) => {
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(AdminTable, {
                        ref_key: "overridesTable",
                        ref: overridesTable,
                        title: "Brand Logo Overrides",
                        icon: "🖼️",
                        columns: columns,
                        data: overrides.value,
                        loading: loading.value,
                        searchable: true,
                        "search-placeholder": "Search overrides...",
                        collapsible: false,
                        "default-expanded": true,
                        editable: true,
                        selectable: false,
                        deletable: true,
                        addable: true,
                        "empty-message": "No overrides yet. Add one below.",
                        onRowEditSave: handleEditSave,
                        onRowDelete: handleDelete,
                        onRowAdd: handleAdd
                    }, {
                        "cell-preview": _withCtx(({ row, editingRowId }) => [
                            (editingRowId === row.id)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (previewPending.value)
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            indeterminate: "",
                                            size: "24",
                                            width: "2"
                                        }))
                                        : (previewSrc.value)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                src: previewSrc.value,
                                                class: "logo-preview",
                                                onError: _cache[0] || (_cache[0] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                            }, null, 40, _hoisted_2))
                                            : _createCommentVNode("", true)
                                ], 64))
                                : (row.override)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: 'https://api.sysodev.link/BrandLogos/' + _cleanBrandName(row.override).replace(/[ /]/g, '+'),
                                        class: "logo-preview",
                                        onError: _cache[1] || (_cache[1] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                    }, null, 40, _hoisted_3))
                                    : _createCommentVNode("", true)
                        ]),
                        "add-cell-preview": _withCtx(() => [
                            (previewPending.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    indeterminate: "",
                                    size: "24",
                                    width: "2"
                                }))
                                : (previewSrc.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: previewSrc.value,
                                        class: "logo-preview",
                                        onError: _cache[2] || (_cache[2] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                    }, null, 40, _hoisted_4))
                                    : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["data", "loading"])
                ]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteDialog.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showDeleteDialog).value = $event)),
                    title: "Delete Override",
                    "max-width": "300px",
                    persistent: true
                }, {
                    content: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("p", null, "Are you sure you want to delete this override?", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDelete,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: _cache[3] || (_cache[3] = ($event) => (showDeleteDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showValidationToast.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((showValidationToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[5] || (_cache[5] = ($event) => (showValidationToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(validationMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
